import React, { useState, useEffect } from "react";

import pw1 from "../../assets/1 Personal Work/1.jpg";
import pw2 from "../../assets/1 Personal Work/2.jpg";
import pw3 from "../../assets/1 Personal Work/3.jpg";
import pw4 from "../../assets/1 Personal Work/4.jpg";
import pw5 from "../../assets/1 Personal Work/5.jpg";
import pw6 from "../../assets/1 Personal Work/6.jpg";
import pw7 from "../../assets/1 Personal Work/7.jpg";
import pw8 from "../../assets/1 Personal Work/8.jpg";
import pw9 from "../../assets/1 Personal Work/9.jpg";
import pw10 from "../../assets/1 Personal Work/10.jpg";
import pw11 from "../../assets/1 Personal Work/11.jpg";
import pw12 from "../../assets/1 Personal Work/12.jpg";
import pw13 from "../../assets/1 Personal Work/13.jpg";
import pw14 from "../../assets/1 Personal Work/14.jpg";
import pw15 from "../../assets/1 Personal Work/15.jpg";
import pw16 from "../../assets/1 Personal Work/16.jpg";
import pw17 from "../../assets/1 Personal Work/17.jpg";
import pw18 from "../../assets/1 Personal Work/18.jpg";
import pw19 from "../../assets/1 Personal Work/19.jpg";
import pw20 from "../../assets/1 Personal Work/20.jpg";
import pw21 from "../../assets/1 Personal Work/21.jpg";
import pw22 from "../../assets/1 Personal Work/22.jpg";
import pw23 from "../../assets/1 Personal Work/23.jpg";
import pw24 from "../../assets/1 Personal Work/24.jpg";
import arrowLeft from "../../assets/arrow-left.png";
import arrowRight from "../../assets/arrow-right.png";
import close from "../../assets/close.png";

const images = [
  pw1, pw2, pw3, pw4, pw5, pw6, pw7, pw8, pw9, pw10, pw11, pw12, pw13, pw14, pw15, pw16, pw17, pw18, pw19, pw20, pw21, pw22, pw23, pw24, 
];

const PersonalWork = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [columns, setColumns] = useState(4);
  const [imageColumns, setImageColumns] = useState([]);

  // Responsive column adjustment
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 640) setColumns(1);
      else if (screenWidth < 768) setColumns(2);
      else if (screenWidth < 1024) setColumns(3);
      else setColumns(4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Distribute images across columns
  useEffect(() => {
    if (images.length === 0) return;

    const newColumns = Array.from({ length: columns }, () => []);

    images.forEach((image, index) => {
      const columnIndex = index % columns;
      newColumns[columnIndex].push({ src: image, index });
    });

    setImageColumns(newColumns);
  }, [columns]);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentImageIndex(0);
  };

  const showNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <>
      <div className="bg-[#252525] min-h-screen py-8 xl:px-[150px] lg:px-[150px] px-[30px]">
        <div className="flex gap-4">
          {imageColumns.map((column, colIndex) => (
            <div key={colIndex} className="flex-1 flex flex-col gap-4">
              {column.map((image, imgIndex) => (
                <div key={imgIndex} className="w-full cursor-pointer" onClick={() => openLightbox(image.index)}>
                  <img
                    src={image.src}
                    alt={`Gallery ${image.index + 1}`}
                    className="w-full object-cover shadow-md hover:shadow-xl transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative flex items-center justify-center w-full">
            {/* Previous Button */}
            <button
              onClick={showPrevImage}
              className="absolute left-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={arrowLeft} alt="Previous" />
            </button>

            {/* Image */}
            <img
              src={images[currentImageIndex]}
              alt={`Lightbox ${currentImageIndex + 1}`}
              className="max-w-full max-h-screen"
            />

            {/* Next Button */}
            <button
              onClick={showNextImage}
              className="absolute right-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={arrowRight} alt="Next" />
            </button>

            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white text-3xl w-10 h-10 flex items-center justify-center"
            >
              <img width="24" height="24" src={close} alt="Close" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PersonalWork;
